var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.logo)?_c('img',{attrs:{"src":require(`@/assets/img/drs/${_vm.logo}.svg`)}}):_vm._e(),_c('div',[_c('p',{staticClass:"text-md font-weight-medium mb-1",domProps:{"textContent":_vm._s(_vm.location.name)}}),(_vm.location.address)?_c('p',{staticClass:"text-xs mb-0",domProps:{"textContent":_vm._s(_vm.address)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }